module.exports = __webpack_public_path__ + "img/00041.9b6771cf.webp";